import { toLower } from 'lodash/fp';
import { RouteName } from '@mews-commander/enums';
import { useLocalizeText } from '@mews/framework';
import { AssistantNavigation } from './AssistantNavigation';

export const useNavigationSearchResult = (
    routeName: RouteName,
    titleKey: Mews.TextKey,
    params = {},
    description?: string,
    id?: string
): AssistantNavigation => {
    const localizeText = useLocalizeText();
    const title = localizeText({ textKey: titleKey });

    return {
        id: id || routeName,
        titleKey,
        routeName,
        description,
        params,
        searchValue: toLower(`${title}${description ? ` ${description}` : ''}`),
    } as AssistantNavigation;
};
